import { render, staticRenderFns } from "./PlanATripSection.vue?vue&type=template&id=8a2c45be&scoped=true"
import script from "./PlanATripSection.vue?vue&type=script&lang=js"
export * from "./PlanATripSection.vue?vue&type=script&lang=js"
import style0 from "./PlanATripSection.vue?vue&type=style&index=0&id=8a2c45be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2c45be",
  null
  
)

export default component.exports